import { useParams } from 'react-router-dom';
import { FlowEditor as SharedFlowEditor, validateFlow as sharedValidate, type FlowEditorApi } from '@zengine/flow-editor-ui';
import { getFlow, publishFlow, createFlowScaffold,
  saveDraft,
  getDraft,
  discardDraft,
} from '../api/flows.js';
import { useTenantSlug } from '../hooks/useTenantSlug.js';

export interface FlowEditorProps {
  disableEditor?: boolean;
}

const api: FlowEditorApi = {
  getFlow: (channel, tenantSlug) => getFlow(channel, tenantSlug),
  publishFlow: (channel, flow) => publishFlow(channel, flow),
  createScaffold: (channel, tenantSlug, opts) => createFlowScaffold(channel, tenantSlug, opts),
  saveDraft: (channel, draft) => saveDraft(channel, draft),
  getDraft: (channel) => getDraft(channel),
  discardDraft: (channel) => discardDraft(channel),
};

export function FlowEditor({ disableEditor }: FlowEditorProps): JSX.Element {
  const { id = '', flowId = '' } = useParams<{ id: string; flowId: string }>();
  const tenantSlug = useTenantSlug(id);
  return <SharedFlowEditor flowId={flowId} tenantSlug={tenantSlug} api={api} disableEditor={disableEditor} />;
}

export const validateFlow = sharedValidate;
